import { useTranslation } from 'react-i18next';
import { Button } from 'components/buttons/button';
import { ButtonType } from 'components/buttons/button-types';
import { PopupStore } from '../../popup.store';
import styles from './error-notice.module.scss';

function ErrorNotice({ popupStore }: { popupStore: PopupStore }) {
  const { t } = useTranslation();
  return (
    <div className={styles.errorNoticeContainer}>
      <i className={`${'icon-cancel-policy'} ${styles.warning}`} />
      <h4>{t(popupStore.config.heading || '')}</h4>
      {popupStore.config?.hasCancelButton && (
        <div className="d-flex justify-content-center">
          <Button
            meta={{ title: 'Close', name: 'Close', type: ButtonType.OutlineDark }}
            onClick={() => popupStore.defaultClose()}
          ></Button>
        </div>
      )}
    </div>
  );
}

export default ErrorNotice;